<template>
  <div class="view-onboardinglicense">
    <subscription-ordering-form @done="onOrdered()" :same-page="true">
      <h1>{{ $t("headings.chooseSubscriptionPlan") }}</h1>
      <p>
        {{ $t("texts.onboardingSubscription") }}
      </p>
    </subscription-ordering-form>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import SubscriptionOrderingForm from "../purchasing/SubscriptionOrderingForm.vue";

const route = useRoute();
const router = useRouter();

const redirectPath = computed(() => {
  if (route.redirectedFrom) {
    return {
      path: route.redirectedFrom.path,
      params: route.redirectedFrom.params
    };
  }
  return {
    name: "models-explorer"
  };
});

function onOrdered() {
  router.push(redirectPath.value);
}
</script>

<style lang="scss">
.view-onboardinglicense {
  overflow: auto;
  overflow-y: scroll;
  padding: 0 1rem;
}
</style>
